import { ACCESS_ERRORS } from "../common/access-errors.js";

export const MEMBER_ERRORS = {
	NOT_FOUND: "member_not_found",
	CANNOT_CHANGE_OWNER_ROLE: "cannot_change_owner_role",
	CANNOT_DEMOTE_SELF: "cannot_demote_self",
	INSUFFICIENT_PERMISSIONS: ACCESS_ERRORS.INSUFFICIENT_PERMISSIONS,
	SKILL_NAME_TAKEN: "skill_name_taken",
	INVALID_SKILL_IDS: "invalid_skill_ids",
	UNAVAILABLE_DATE_NOT_FOUND: "unavailable_date_not_found",
	UNAVAILABLE_DATE_ALREADY_EXISTS: "unavailable_date_already_exists",
} as const;

export type MemberErrorCode = (typeof MEMBER_ERRORS)[keyof typeof MEMBER_ERRORS];
